import { createAction } from 'redux-actions'
import {
  SET_DELIVERY_DATA,
  SET_DELIVERY_AMOUNT,
  SET_DELIVERY_COUPON,
  REQUEST_DELIVERY_UNSUBSCRIPTION_DATA,
  REQUEST_DELIVERY_DATA
} from '../constants/deliveryConstant'

export let requestDeliveryUnsubscriptionData = createAction(REQUEST_DELIVERY_UNSUBSCRIPTION_DATA)
export let requestDeliveryData = createAction(REQUEST_DELIVERY_DATA)
export let setDeliveryData = createAction(SET_DELIVERY_DATA)
export let setDeliveryAmount = createAction(SET_DELIVERY_AMOUNT)
export let setDeliveryCoupon = createAction(SET_DELIVERY_COUPON)
